import { GrBox, GrTypography } from "@jnpmedi/grebob";
import { getColorBySignerIndex, getFieldTypeWithAttr } from "@newComponents/common/Viewer/types";
import { MvnMessage } from "@newLibs/utils";
import { DocumentMarker, useDocumentMarkerContext } from "@newHooks/context/document/documentMarker.context";
import { DOCS_DOCUMENT_LANG, DOCS_ECONSENT_LANG } from "@maven-msg/lang/docs";
import { DocumentSignerAttrType } from "@maven-rest/docs/DocumentSign.dto";
import { uniq } from "lodash";

export function EConsentMarkerLabel({ marker }: { marker: DocumentMarker }) {
  const { markers } = useDocumentMarkerContext();

  const getReadableSignerIndex = (signerIndex: number) =>
    ((v) => v.indexOf(signerIndex) + 1)(uniq(markers.map((e) => e.signerIndex).sort((a, b) => a - b)));

  const markerLabel = (marker: DocumentMarker) => {
    return (
      <>
        {(() => {
          const { attr } = marker;
          if ([DocumentSignerAttrType.Signature, DocumentSignerAttrType.AgentSignature, DocumentSignerAttrType.Sign].includes(attr)) {
            return "Sign";
          }

          const fieldType = getFieldTypeWithAttr(attr);
          if (fieldType) return fieldType;

          return attr.charAt(0) + attr.slice(1).toLowerCase();
        })()}
      </>
    );
  };

  const isSigneeAttr = getReadableSignerIndex(marker.signerIndex) === 1 && marker.attr.slice(0, 5) !== "AGENT";
  const isInvestigatorAttr = getReadableSignerIndex(marker.signerIndex) === 2;
  const isAgentAttr = getReadableSignerIndex(marker.signerIndex) === 1 && marker.attr.slice(0, 5) === "AGENT";

  if (
    marker.attr === DocumentSignerAttrType.AgentAvailableMark ||
    marker.attr === DocumentSignerAttrType.AgentResponsiveItemFieldMark ||
    marker.attr === DocumentSignerAttrType.ResponsiveItemFieldMark
  ) {
    return <></>;
  }
  return (
    <GrBox>
      <GrTypography type="Content.Body04" color={getColorBySignerIndex(marker.signerIndex).text}>
        {markerLabel(marker)}
      </GrTypography>

      {marker.target === "SIGNER" && (
        <GrTypography type="Content.Caption04" color={getColorBySignerIndex(marker.signerIndex).text}>
          {isSigneeAttr && `(${MvnMessage(DOCS_ECONSENT_LANG.NTH_SIGNER_LABEL)})`}
          {isInvestigatorAttr && `(${MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_NTH_INVESTIGATOR_SHORT_LABEL)})`}
          {isAgentAttr && `(${MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_ECONSENT_AGENT)})`}
        </GrTypography>
      )}
    </GrBox>
  );
}
